import * as LDClient from 'launchdarkly-js-client-sdk'

class FlagsService {
  constructor () {
    this.isReady = false
    this.client = undefined
  }

  async init () {
    return new Promise((resolve) => {
      this.client = LDClient.initialize('62396f19f1543014a6e0e3d9', { key: 'staging user' })
      this.client.on('ready', () => setTimeout(resolve, 100))
    })
  }

  getFlagValue (flagName) {
    return this.client.variation(flagName)
  }
}

export default new FlagsService()
